import React, { useEffect, useState } from 'react';
let deferredPrompt;
const A2hs = (props) => {

  const [installable, setInstallable] = useState(false);
  const [smallPrompt, setSmallPrompt] = useState(false);

  useEffect(() => {

    if (!props.displayClientComp) {
      // Unregister the service worker if already registerd for dektop
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (let registration of registrations) {
            if (registration && (registration.scope.includes('localhost') || registration.score.includes('myjosh.in'))) {
              registration.unregister()
            }
            console.log("Service worker", registration)
          }
        }).catch(function (err) {

          console.log('Service Worker registration failed: ', err);

        });
      }
      return;
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(() => { console.log('Service Worker Registered'); });
    }

    let sessCount = false;
    var n = localStorage && localStorage.getItem('lastSession');
    if (n === null) {
      n = 1;
    } else {
      n++;
      if (n == 10) {
        n = 4
      }
    }
    // console.log(n);
    localStorage && localStorage.setItem("lastSession", n);


    if (window && window.localStorage && window.localStorage.getItem('lastSession')) {
      let lastSession = window.localStorage.getItem('lastSession');
      sessCount = Number(lastSession);
    }
    // console.log("sessCount", sessCount)
    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      // setInstallable(true);


      if (sessCount && sessCount > 1 && sessCount % 5 == 0) {
        setSmallPrompt(true);
      } else if (sessCount && sessCount == 1) {
        setInstallable(true);
      }

    });



    window.addEventListener('appinstalled', () => {
      // Log install to analytics
      console.log('INSTALL: Success');
    });
  }, []);

  const handleInstallClick = (e) => {
    // Hide the app provided install promotion
    setInstallable(false);
    setSmallPrompt(false);
    // pushEntityCard('click')
    // pushGeneric({
    //   type: 'pwa_dh_a2hs',
    //   action: 'allow',
    //   neverShow: false
    // }, "DIALOGBOX_ACTION");
    // Show the install prompt
    if (deferredPrompt) {
      deferredPrompt.prompt();
    }
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
        // pushGeneric({type: 'pwa_browser_a2hs', action:'allow', seen_count: 1, neverShow: false},'DIALOGBOX_ACTION');
      } else {
        console.log('User dismissed the install prompt');
        // pushGeneric({type: 'pwa_browser_a2hs', action:'dismiss', seen_count: 1, neverShow: true}, 'DIALOGBOX_ACTION');
      }
      deferredPrompt = null;
    });
  };


  const handleLatterClick = (e) => {
    e.stopPropagation();
    setInstallable(false);
    setSmallPrompt(false);
  };

  if (!props.displayClientComp) {
    return null;
  }

  return (
    <>
      {
        installable && <div className="Add2HS" id="install-button">
          <table>
            <tr>
              <td className="w36">
                <figure>
                  <img src="/static/images/josh/icn_a2hs.svg" alt="a2hs" />
                </figure>
              </td>
              <td>
                <div className="details">
                  <p>Add <strong>Josh</strong> to your home screen</p>
                  <span>www.josh.com</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="2" className="TAR">
                <ul>
                  <li onClick={(e) => handleLatterClick(e)}>LATER</li>
                  <li onClick={handleInstallClick} className="active">ADD TO HOME</li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      }

      {
        smallPrompt &&
        //   <div class="Add2HS" id="install-button">
        //   <table style={{marginBottom:"12px"}}>
        //     <tr onClick={handleInstallClick}>
        //       <td className="w36">
        //         <figure>
        //           <img src="/static/images/josh/icn_a2hs.svg" />
        //         </figure>
        //       </td>
        //       <td>
        //         <div className="details">
        //           <p>Add <strong>Josh</strong> to your home screen</p>
        //         </div>
        //       </td>
        //       <td  onClick={(e)=>handleLatterClick(e)} className="w36">
        //         <span className="icn_close"></span>
        //       </td>
        //     </tr>
        //   </table>
        // </div>
        <div className="Add2HS theme-dark" id="install-button">
          <table style={{ marginBottom: "12px" }}>
            <tr onClick={handleInstallClick}>
              <td className="w36">
                <figure>
                  <img src="/static/images/josh/icn_a2hs.svg" alt="a2hs" />
                </figure>
              </td>
              <td>
                <div className="details">
                  <p>Add <strong>Josh</strong> to your home screen</p>
                </div>
              </td>
              <td className="w36" onClick={(e) => handleLatterClick(e)} >
                <span className="icn_close"></span>
              </td>
            </tr>
          </table>
        </div>
      }

    </>
  )
}


export { A2hs };
